// extracted by mini-css-extract-plugin
export default {"media-box-grid":"Statistics_media-box-grid__5o0NR"};